import React, { useEffect, useState } from 'react';
import "./OperatProf.css"
import ProgressBar from 'react-bootstrap/ProgressBar';
import ReactStars from "react-rating-stars-component";

const RviewBarsSection = ({ operatorAllReviews, reviewAll }) => {
    const [feedbackData, setFeedbackData] = useState(0);
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    useEffect(() => {
        if (reviewAll?.averageRating !== undefined) { // Check if averageRating exists (even if it's 0)
            setFeedbackData(reviewAll.averageRating);
            setIsDataLoaded(true); // Mark data as loaded
        }
    }, [reviewAll]);

    if (!reviewAll?.ratingDistribution) return null;

    const ratingDistribution = reviewAll.ratingDistribution;
    const totalRatings = Object.values(ratingDistribution).reduce((acc, val) => acc + val, 0);

    const getPercentage = (value) => (totalRatings ? Math.round((value / totalRatings) * 100) : 0);
    return (
        <>
            <div
                className=""
            >
                <div className='travTextReview'>Traveler's Reviews</div>
                <div className='starSection'>
                    {isDataLoaded && (
                        <ReactStars
                            count={5}
                            value={feedbackData}
                            size={24}
                            activeColor="#ffd438"
                            isHalf={true}
                            precision={0.1}
                            edit={false}
                            className="starsColor"
                        />
                    )}
                    <div>{reviewAll?.averageRating} out of 5</div> </div>
                <div>Based on {reviewAll?.totalReviews} reviews</div>
                <div>
                    {['fiveStar', 'fourStar', 'threeStar', 'twoStar', 'oneStar'].map((star, index) => {
                        const starNumber = 5 - index;
                        const percentage = getPercentage(ratingDistribution[star]);
                        return (
                            <div key={star} className="starSection TextBlueColor">
                                <span className='starsLeftText'>{starNumber} star:</span>  <ProgressBar className="custom-progress-bar" now={percentage} /> <span className='starsLeftText'>{percentage}%</span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    )
}

export default RviewBarsSection
